import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AuthGuard } from './_helpers/auth.guard';
import { HomedetailsComponent } from './homedetails/homedetails.component';
import { DamComponent } from './dam/dam.component';
import { SigninComponent } from './signin/signin.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { PricingComponent } from './pricing/pricing.component';
import { UploadComponent } from './upload/upload.component';
import { PeopleComponent } from './people/people.component';
import { PersonalComponent } from './personal/personal.component';
import { NewboardComponent } from './newboard/newboard.component';
import { SubscriptionComponent } from './subscription/subscription.component';
import { BoarddataComponent } from './boarddata/boarddata.component';
import { SettingsComponent } from './settings/settings.component';
import { DropzonComponent } from './dropzon/dropzon.component';
import { CreateOrganisationComponent } from './create-organisation/create-organisation.component';
import { FaqComponent } from './faq/faq.component';
import { TermsComponent } from './terms/terms.component';
import { EnterpriseComponent } from './enterprise/enterprise.component';
import { EditboardComponent } from './editboard/editboard.component';
import { WorkspacesComponent } from './workspaces/workspaces.component';
import { InviteUsersRegistreComponent } from './invite-users-registre/invite-users-registre.component';
import { InboxareaComponent } from './inboxarea/inboxarea.component';
import { VerificationComponent } from './verification/verification.component';
import { AllworkspacesComponent } from './allworkspaces/allworkspaces.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { PaymentComponent } from './payment/payment.component';
import { SuccessComponent } from './success/success.component';
import { ShareComponent } from './share/share.component';
import { ShareboardComponent } from './shareboard/shareboard.component';
import { AppsComponent } from './apps/apps.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { FeaturesComponent } from './features/features.component';
import { TaggingComponent } from './tagging/tagging.component';
import { SharingComponent } from './sharing/sharing.component';
import { CheckoutComponent } from './checkout/checkout.component';
import { VersionComponent } from './version/version.component';
import { CollabComponent } from './collab/collab.component';
import { IntegrationComponent } from './integration/integration.component';
import { ArchiveComponent } from './archive/archive.component';
import { StorageComponent } from './storage/storage.component';
import { SearchComponent } from './search/search.component';
import { ApprovalsComponent } from './approvals/approvals.component';
import { PartnershipComponent } from './partnership/partnership.component';
import { MissionComponent } from './mission/mission.component';
import { ShowcaseComponent } from './showcase/showcase.component';
import { CommunityComponent } from './community/community.component';
import { DropAlterComponent } from './drop-alter/drop-alter.component';
import { DriveAlterComponent } from './drive-alter/drive-alter.component';
import { BoxAlterComponent } from './box-alter/box-alter.component';
import { TeamCollaborationComponent } from './team-collaboration/team-collaboration.component';
import { LearningComponent } from './learning/learning.component';
import { ProfileComponent } from './profile/profile.component';
import { MarketingComponent } from './marketing/marketing.component';
import { LibraryComponent } from './library/library.component';
import { PublicProfileComponent } from './public-profile/public-profile.component';
import { ContentLibraryComponent } from './content-library/content-library.component';
import { AboutComponent } from './about/about.component';
import { OfferCheckoutComponent } from './offer-checkout/offer-checkout.component';
import { OfferSignupComponent } from './offer-signup/offer-signup.component';
import { OfferAppsumoComponent } from './offer-appsumo/offer-appsumo.component';
import { WelcomeKitComponent } from './welcome-kit/welcome-kit.component';
import { VideosKitComponent } from './videos-kit/videos-kit.component';
import { InQueueComponent } from './in-queue/in-queue.component';
import { ProfilingComponent } from './profiling/profiling.component';
import { CelebrateSubscriberComponent } from './celebrate-subscriber/celebrate-subscriber.component';
import { MobileComponent } from './mobile/mobile.component';
import { BetaPgmComponent } from './beta-pgm/beta-pgm.component';
import { CompetitionComponent } from './competition/competition.component';
import { ViewCaseDesignComponent } from './view-case-design/view-case-design.component';
import { AffiliateComponent } from './affiliate/affiliate.component';
import { AiArtComponent } from './ai-art/ai-art.component';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'home', component: HomedetailsComponent },
  { path: 'dam', component: DamComponent },
  { path: 'login', component: SigninComponent },
  { path: 'contact', component: ContactUsComponent },
  { path: 'pricing', component: PricingComponent },
  { path: 'upload', component: UploadComponent },
  { path: 'feedbacks', component: FeedbackComponent },
  { path: 'shared', component: ShareComponent },
  { path: 'shared-board', component: ShareboardComponent },
  { path: 'dam/people', component: PeopleComponent },
  { path: 'dam/personal', component: PersonalComponent },
  { path: 'dam/create-board', component: NewboardComponent },
  { path: 'dam/inbox', component: InboxareaComponent },
  { path: 'dam/verification', component: VerificationComponent },
  { path: 'dam/subscription', component: SubscriptionComponent },
  { path: 'dam/payment', component: PaymentComponent },
  { path: 'dam/settings', component: SettingsComponent },
  { path: 'dam/payment-success', component: SuccessComponent },
  { path: 'dam/trash', component: ArchiveComponent },
  { path: 'dam/:boardId', component: BoarddataComponent },
  { path: 'how-it-works', component: WelcomeKitComponent },
  { path: 'create-workspace', component: CreateOrganisationComponent },
  { path: 'faq', component: FaqComponent },
  { path: 'terms', component: TermsComponent },
  { path: 'workspaces', component: WorkspacesComponent },
  { path: 'invited-users', component: InviteUsersRegistreComponent },
  { path: 'features', component: FeaturesComponent },
  { path: 'payment-customplan', component: CheckoutComponent },
  { path: 'features/tagging', component: TaggingComponent },
  { path: 'features/sharing', component: SharingComponent },
  { path: 'features/versioning', component: VersionComponent },
  { path: 'features/collaboration', component: CollabComponent },
  { path: 'features/integration', component: IntegrationComponent },
  { path: 'smart-storage', component: StorageComponent },
  { path: 'effective-search', component: SearchComponent },
  { path: 'approvals', component: ApprovalsComponent },
  { path: 'partner-with-us', component: PartnershipComponent },
  { path: 'our-mission', component: MissionComponent },
  { path: 'dropbox-alternative', component: DropAlterComponent },
  { path: 'google-drive-alternative', component: DriveAlterComponent },
  { path: 'box-alternative', component: BoxAlterComponent },
  { path: 'library', component: LibraryComponent },
  { path: 'my-profile', component: ProfileComponent },
  { path: 'user-profiling', component: ProfilingComponent },
  { path: 'content-library', component: ContentLibraryComponent },
  { path: 'offer-checkout-ajgdhjaduabsjxcssjheuw', component: OfferCheckoutComponent },
  { path: 'login-asiuashjasustfgvhg', component: OfferSignupComponent },
  { path: 'login-appsiuashjasustsumofgvhg', component: OfferAppsumoComponent },
  { path: 'shared-profile', component: PublicProfileComponent },
  { path: 'about-workspace', component: AboutComponent },
  { path: 'mobile-apps', component: MobileComponent },
  // { path: 'ai-artists', component: AiArtComponent },
  // { path: 'affiliate-pgm', component: AffiliateComponent },
  // { path: 'happy-subscribers', component: CelebrateSubscriberComponent },
  // { path: 'beta-program', component: BetaPgmComponent },
  // { path: 'design-competition', component: CompetitionComponent },
  // { path: 'design-cases', component: ViewCaseDesignComponent },
  // { path: 'videos-kit', component: VideosKitComponent },
  // { path: 'company', component: EnterpriseComponent },
  // { path: 'community', component: CommunityComponent },
  // { path: 'marketing', component: MarketingComponent },
  // { path: 'project-teams', component: TeamCollaborationComponent },
  // { path: 'learning', component: LearningComponent },
  // { path: 'dam/dropzon', component: DropzonComponent },
  // { path: 'dam/feature-requests', component: InQueueComponent },
  // { path: 'dam/showcase', component: ShowcaseComponent },
  // { path: 'dam/all-workspaces', component: AllworkspacesComponent },
  // { path: 'dam/edit-board', component: EditboardComponent },
  // { path: 'dam/apps', component: AppsComponent },
  // { path: 'maintenance', component: MaintenanceComponent },



  // { path: '', component: MaintenanceComponent },
  // { path: 'home', component: MaintenanceComponent },
  // { path: 'dam', component: MaintenanceComponent },
  // { path: 'login', component: MaintenanceComponent },
  // { path: 'contact', component: MaintenanceComponent },
  // { path: 'pricing', component: MaintenanceComponent },
  // { path: 'upload', component: MaintenanceComponent },
  // { path: 'feedbacks', component: MaintenanceComponent },
  // { path: 'shared', component: MaintenanceComponent },
  // { path: 'shared-board', component: MaintenanceComponent },
  // { path: 'dam/people', component: MaintenanceComponent },
  // { path: 'dam/personal', component: MaintenanceComponent },
  // { path: 'dam/create-board', component: MaintenanceComponent },
  // { path: 'dam/inbox', component: MaintenanceComponent },
  // { path: 'dam/verification', component: MaintenanceComponent },
  // { path: 'dam/all-workspaces', component: MaintenanceComponent },
  // // { path: 'dam/edit-board', component: EditboardComponent },
  // // { path: 'dam/apps', component: AppsComponent },
  // { path: 'dam/subscription', component: MaintenanceComponent },
  // { path: 'dam/payment', component: MaintenanceComponent },
  // { path: 'dam/settings', component: MaintenanceComponent },
  // { path: 'dam/payment-success', component: MaintenanceComponent },
  // { path: 'dam/dropzon', component: MaintenanceComponent },
  // { path: 'dam/trash', component: MaintenanceComponent },
  // { path: 'dam/videos-kit', component: VideosKitComponent },
  // { path: 'dam/welcome-kit', component: MaintenanceComponent },
  // // { path: 'dam/showcase', component: ShowcaseComponent },
  // { path: 'dam/:boardId', component: MaintenanceComponent },
  // { path: 'create-workspace', component: MaintenanceComponent },
  // { path: 'faq', component: MaintenanceComponent },
  // { path: 'terms', component: MaintenanceComponent },
  // // { path: 'company', component: EnterpriseComponent },
  // { path: 'workspaces', component: MaintenanceComponent },
  // { path: 'invited-users', component: MaintenanceComponent },
  // { path: 'maintenance', component: MaintenanceComponent },
  // { path: 'features', component: MaintenanceComponent },
  // { path: 'payment-customplan', component: MaintenanceComponent },
  // { path: 'features/tagging', component: MaintenanceComponent },
  // { path: 'features/sharing', component: MaintenanceComponent },
  // { path: 'features/versioning', component: MaintenanceComponent },
  // { path: 'features/collaboration', component: MaintenanceComponent },
  // { path: 'features/integration', component: MaintenanceComponent },
  // { path: 'smart-storage', component: MaintenanceComponent },
  // { path: 'effective-search', component: MaintenanceComponent },
  // { path: 'approvals', component: MaintenanceComponent },
  // { path: 'partner-with-us', component: MaintenanceComponent },
  // { path: 'our-mission', component: MaintenanceComponent },
  // { path: 'dropbox-alternative', component: MaintenanceComponent },
  // { path: 'google-drive-alternative', component: MaintenanceComponent },
  // { path: 'box-alternative', component: MaintenanceComponent },
  // { path: 'library', component: MaintenanceComponent },
  // { path: 'my-profile', component: MaintenanceComponent },
  // { path: 'content-library', component: MaintenanceComponent },
  // { path: 'about-workspace', component: MaintenanceComponent },
  // { path: 'offer-checkout-ajgdhjaduabsjxcssjheuw', component: MaintenanceComponent },
  // { path: 'login-asiuashjasustfgvhg', component: MaintenanceComponent },
  // { path: 'login-appsiuashjasustsumofgvhg', component: MaintenanceComponent },
  // { path: 'shared-profile', component: MaintenanceComponent },
  // { path: 'community', component: MaintenanceComponent },
  // { path: 'marketing', component: MaintenanceComponent },
  // { path: 'project-teams', component: MaintenanceComponent },
  // { path: 'learning', component: MaintenanceComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{
    scrollPositionRestoration: 'enabled'
  })],
  exports: [RouterModule]
  // imports: [RouterModule.forRoot(routes , { useHash: true })],
  // imports: [RouterModule.forRoot(routes)],
  // exports: [RouterModule]
})
export class AppRoutingModule { }
